module.exports = __webpack_public_path__ + "static/media/checkbox-on.b0832d7c.svg";